"use strict";
// @ts-ignore
try {
    self['workbox:strategies:7.3.0'] && _();
}
catch (e) { }
